// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5362":"5cc35dc2","8361":"582400ee","8992":"c6448101"}[chunkId] + ".chunk.css";
};